import { fetchApp, selectAppById } from "@app/deploy";
import { useQuery, useSelector } from "@app/react";
import {
  appActivityUrl,
  appDetailDeploymentsUrl,
  appServicesUrl,
} from "@app/routes";
import { Navigate, useParams } from "react-router";
import { Loading } from "../shared";

export const AppDetailPage = () => {
  const { id = "" } = useParams();
  // Which tab we land on depends on whether the app has ever deployed, so we
  // have to let it load before redirecting — an empty store would otherwise
  // send every app to Deployments on a cold load.
  const loader = useQuery(
    fetchApp({ id, withDeleted: true, waitForBootup: true }),
  );
  const app = useSelector((s) => selectAppById(s, { id }));

  if (loader.isInitialLoading) {
    return <Loading />;
  }

  if (app.deletedAt) {
    return <Navigate to={appActivityUrl(id)} replace />;
  }

  // Never deployed, so Services has nothing to show — send them to Deployments
  // where they can kick off a first deploy.
  if (!app.currentDeploymentId) {
    return <Navigate to={appDetailDeploymentsUrl(id)} replace />;
  }

  return <Navigate to={appServicesUrl(id)} replace />;
};
